import { createAction } from '@reduxjs/toolkit';

export const replaceHistoryState = createAction(
  'history/replaceState',
  (reason) => ({ payload: { reason } }),
);
